module.exports = __webpack_public_path__ + "static/img/JOSH-LINDSAY.449f80d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JOSH-LINDSAY.jpg
// module id = BZsf
// module chunks = 0